import { randomBytes, createHash } from 'crypto'

/**
 * Generates a random nonce for Content Security Policy
 * @returns string - A random nonce string
 */
export function generateNonce(): string {
  return randomBytes(16).toString('base64')
}

/**
 * Generates a nonce based on request-specific data
 * @param pathName - The request path
 * @param deviceType - The device type
 * @param timestamp - Optional timestamp, defaults to current time
 * @returns string - A deterministic nonce based on input parameters
 */
export function generateRequestNonce(pathName: string, deviceType: string, timestamp?: number): string {
  const time = timestamp || Date.now()
  const input = `${pathName}-${deviceType}-${time}`

  // Create a hash of the input string
  const hash = createHash('sha256')
  hash.update(input)
  return hash.digest('base64').substring(0, 16)
}
